module.exports = __webpack_public_path__ + "static/payment20-26f0edd49501b29dc27fbde15f00d863.jpg";